import ColorImage from 'app/React/Components/Main/ColorImage'
import StepImage from 'app/React/Components/Main/StepImage'
import React, { useContext } from 'react'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";
import { getConfigurationColorOption } from "app/React/Helpers/ColorImageHelper";

export default function WidgetStepFigure(props) {
  const {
    car,
    colorSettingId,
    currentVariant,
    isDealerConfigurator,
    order
  } = useContext(ConfiguratorContext)

  const colorOption = getConfigurationColorOption(order.configuration, colorSettingId)

  if (props.step === null) {
    return null
  }

  return (
    <div className='mtt-product__image-wrap sticky'>
      <div className='mtt-product__logo'>
        <div className='mtt-product__logo-text'>
          {car.title}
        </div>
      </div>
      <div className='mtt-product__image-container'>
        <div className='mtt-product__image-title'>
          {car.car_model}
        </div>
        <ColorImage>
          <StepImage step={props.step}/>
        </ColorImage>
      </div>
      {
        !isDealerConfigurator ? (
          <div
            className='mandatory-information is-widget'
            dangerouslySetInnerHTML={{ __html: currentVariant.mandatory_information ?? null }}
          />
        ) : null
      }
      <div className='mtt-product__image–active-texts'>
        <div className='mtt-product__image–active-style'>
          <span>Style</span>
          {currentVariant?.title}
        </div>

        <div className='mtt-product__image–active-color'>
          <span>{colorOption?.title}</span>
        </div>
      </div>
    </div>
  )
}

WidgetStepFigure.defaultProps = {
  usps: true,
  step: null,
  layout: 'contained' // full
}
